export default __webpack_public_path__ + "static/media/killer-feature-output.35794223.png";